module.exports = __webpack_public_path__ + "img/MILAN HAIR SALON.fbfe4d47.svg";